import { render, staticRenderFns } from "./schoolClassList.vue?vue&type=template&id=398a5845&scoped=true"
import script from "./schoolClassList.vue?vue&type=script&lang=js"
export * from "./schoolClassList.vue?vue&type=script&lang=js"
import style0 from "./schoolClassList.vue?vue&type=style&index=0&id=398a5845&prod&lang=scss&scoped=true"
import style1 from "./schoolClassList.vue?vue&type=style&index=1&id=398a5845&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398a5845",
  null
  
)

export default component.exports